import {getObject,postObjectWithApiError, IResultAndError} from '../../lib/ChoiceApi'; 
import {IPlanSetup,IDeferPlan,IPaymentPlanDetails,IPaymentPlanCreate,IPaymentPlanStatusUpdate,
        IPaymentPlanClaimUpdates,IPaymentPlanUpdate,IRespPartyUpdate,IPaymentPlanCardUpdate,
        IInstallmentDisplay,IPlanSummary,IPaymentReportInputs,IPaymentPlanPayReport,IPrintPlanDetails,IPatientPaymentPlanMessage} from '../../lib/Models/PaymentPlanModel'; 
import {IBillingResponse} from '../../lib/Models/ClaimModel';
import {ISelectedPlans,IRecurringPlanList} from '../../lib/Models/PaymentPlanProcessModel';  

export enum ErrorReturnMessage {
    details = "Unable to obtain payment plan details",
    setup = "Unable to obtain payment plan setup information",
    save = "Unable to save new payment plan",
    updateStatus = "Unable to update payment plan status",
    updateClaims = "Unable to update payment plan claim list",
    defer = "Unable to defer payment plan",
    changeRP = "Unable to change responsible party",
    cardUpdate = "Unable to update credit card",
    planProcess = "Unable to get Payment Plan List",
    installmentDisplay = "Unable to get Installments",
    reportDisplay = "Unable to get Reporting Data",
    printDisplay = "Unable to get Print Details",
    patientMessage = "Unable to obtain patient payment plan messages"
};

export async function getPayPlanSetup(patientId: number): Promise<IResultAndError<IPlanSetup>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/PaymentPlan/PayPlanSetup/${patientId}`; 
    const responseObject = await getObject<IPlanSetup>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.setup;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}
export async function getPayPlanDetails(paymentPlanId: number): Promise<IResultAndError<IPaymentPlanDetails>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/PaymentPlan/PayPlanDetails/${paymentPlanId}`;
    const responseObject = await getObject<IPaymentPlanDetails>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.details;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}
export async function getPrintDetails(paymentPlanId: number): Promise<IResultAndError<IPrintPlanDetails>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/PaymentPlan/PrintDetails/${paymentPlanId}`;
    const responseObject = await getObject<IPrintPlanDetails>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.printDisplay;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
}
export async function createPaymentPlan(payload: IPaymentPlanCreate): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/CreatePaymentPlan", payload);
};
export async function updatePaymentPlanStatus(payload: IPaymentPlanStatusUpdate): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/UpdatePaymentPlanStatus", payload);
};
export async function updatePaymentPlan(payload: IPaymentPlanUpdate): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/UpdatePaymentPlan", payload);
};
export async function updatePaymentPlanClaims(payload: IPaymentPlanClaimUpdates): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/UpdatePaymentPlanClaims", payload);
};
export async function deferPaymentPlan(payload: IDeferPlan): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/DeferPaymentPlan", payload);
};
export async function changeRP(payload: IRespPartyUpdate): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/ChangeResponsibleParty", payload);
};
export async function updatePaymentPlanCreditCard(payload: IPaymentPlanCardUpdate): Promise<IResultAndError<IBillingResponse>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/UpdatePaymentPlanCreditCard", payload);
};
export async function getPaymentPlanProcess(payload: ISelectedPlans): Promise<IResultAndError<IRecurringPlanList>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/PaymentPlanProcess", payload);
};
export async function getPayPlanInstallments(payload: IInstallmentDisplay): Promise<IResultAndError<IPlanSummary[]>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/PayPlanInstallments", payload);
};
export async function getPaymentReport(payload: IPaymentReportInputs): Promise<IResultAndError<IPaymentPlanPayReport[]>>{
    return postObjectWithApiError("api/Billing/PaymentPlan/PaymentReport", payload);
}; 
export async function getPatientPlanMessage(patientId: number): Promise<IResultAndError<IPatientPaymentPlanMessage>>{  
    let returnErrorMessage = "";
    const url = `api/Billing/PaymentPlan/PatientPaymentPlanMessaging/${patientId}`; 
    const responseObject = await getObject<IPatientPaymentPlanMessage>(url,(httResp, errorMessage) =>  { 
        returnErrorMessage = errorMessage ?? ErrorReturnMessage.patientMessage;
    });
    if (responseObject)
        return {success: responseObject};
    else 
        return {error: {error: returnErrorMessage}}; 
} 

